import React from 'react'

import PdfSection from '@/components/misc/ReferralESignatureConsentPdf/components/PdfSection'
import { ReferralESignatureItemCompanyGroup } from '@/types/responses/referrals'

interface Props {
  toCompanyGroup: ReferralESignatureItemCompanyGroup
  otherToCompanyGroupNames: string[]
}

const AppendixSection: React.FC<Props> = ({
  toCompanyGroup,
  otherToCompanyGroupNames,
}) => {
  return (
    <PdfSection className="mt-6">
      <h3
        className="border-t pt-4 mt-9 mb-1.5 font-semibold
          text-muted-foreground"
      >
        Other {toCompanyGroup.name} firms
      </h3>

      <ul className="flex flex-col gap-0.5">
        {otherToCompanyGroupNames.map((name) => (
          <li key={name}>{name}</li>
        ))}
      </ul>
    </PdfSection>
  )
}

export default AppendixSection
